import { App, Button } from 'antd'
import { PROFILE_URL } from '../../helpers/urls'
import { SBAPIPost } from '../../helpers/SBAPIHelper'
import { useState } from 'react'

interface Props {
  profileSlug: string
}

export const SubscribeInstagramWebhook = ({ profileSlug }: Props) => {
  const { message } = App.useApp()
  const [isLoading, setIsLoading] = useState<boolean>(false)

  return (
    <Button
      onClick={() => {
        setIsLoading(true)
        SBAPIPost(`${PROFILE_URL}/${profileSlug}/subscribe-instagram-webhooks`)
          .then(() => message.success('Webhooks subscribed'))
          .catch(() => message.error('Webhooks subscription failed'))
          .finally(() => setIsLoading(false))
      }}
    >
      Subsribe to Instagram webhooks
    </Button>
  )
}

export type SubscribeInstagramWebhookType = {
  SubscribeInstagramWebhook: typeof SubscribeInstagramWebhook
}
